export default "__VITE_ASSET__944199b5__"